<template>
  <div class="alert-box is-flex" :class="`alert-box--${type}`">
    <div class="alert-box__exclaim">
      <img :src="`/static/img/ads/exclaim_${type}.svg`"/>
    </div>
    <div class="alert-box__message-box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlertMessage',
  props: {
    type: {
      // Possible values: info, warning
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.alert-box {
  margin-bottom: 10px;
}

.alert-box__exclaim {
  position: relative;
  min-width: 34px;
}

.alert-box__exclaim img {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 0;
  right: 0;
}

.alert-box__message-box {
  font-size: 12px;
  border-left: none !important;
  width: 100%;
  padding: 11px 12px;
}

.alert-box--info {
  background-color: rgba(48, 170, 225, 0.05);
  border: 1px solid #30aae1;
  color: #30aae1;
}

.alert-box--info .alert-box__exclaim {
  border-right: 1px solid #30aae1;
}

.alert-box--warning {
  background-color: rgba(228, 134, 44, 0.05);
  border: 1px solid #e4862c;
  color: #e4862c;
}

.alert-box--warning .alert-box__exclaim {
  border-right: 1px solid #e4862c;
}
</style>



// WEBPACK FOOTER //
// src/components/AlertMessage.vue